export const ARTICLE_BOOKMARK_COOKIE = 'bookmarkArticle';
